/**
 * Downloads a file from a data: URL or any URL by converting it to a Blob first.
 * Using fetch → blob → createObjectURL avoids browser size limits on data: URLs
 * and works reliably across Chrome, Firefox, and Safari for large binary files.
 */
export async function downloadBlobFile(fileUrl: string, fileName: string): Promise<void> {
    const res = await fetch(fileUrl);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
}

/**
 * Downloads a plain object as a formatted .json file, using the same
 * Blob + ObjectURL approach as downloadBlobFile for consistent, reliable behavior.
 */
export function downloadJSON(data: any, fileName: string): void {
    const blob = new Blob([JSON.stringify(data, null, 3)], { type: 'application/json' });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
}

export const DOC_EXT_ICONS: Record<string, string> = {
    pptx: '🟦',
    docx: '🟩',
    xlsx: '🟨',
    pdf:  '🟥',
};
